import { render, staticRenderFns } from "./BuildStandards.vue?vue&type=template&id=23de0861"
import script from "./BuildStandards.vue?vue&type=script&lang=js"
export * from "./BuildStandards.vue?vue&type=script&lang=js"
import style0 from "./BuildStandards.vue?vue&type=style&index=0&id=23de0861&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports